<button
  [type]="type"
  [disabled]="disabled || loading"
  [ngClass]="classes"
  (click)="onClick()"
  [attr.aria-label]="ariaLabel || (iconOnly ? iconOnly : null)"
  [attr.aria-busy]="loading ? 'true' : null"
  [attr.aria-disabled]="disabled || loading ? 'true' : null"
>
  <!-- Spinner de chargement -->
  <span *ngIf="loading" class="spinner" aria-hidden="true"></span>

  <!-- Mode icône seule (carré) -->
  <ng-container *ngIf="iconOnly && !loading">
    <!-- Material Icon -->
    <span class="material-icons btn-icon" aria-hidden="true">{{
      iconOnly
    }}</span>
  </ng-container>

  <!-- Mode avec label -->
  <ng-container *ngIf="!iconOnly">
    <!-- Icône GAUCHE : Material Icons (string) -->
    <span
      *ngIf="iconLeft && !iconLeftClass && !loading"
      class="material-icons btn-icon btn-icon--left"
      aria-hidden="true"
      >{{ iconLeft }}</span
    >

    <!-- Icône GAUCHE : classe personnalisée (FontAwesome, etc.) -->
    <i
      *ngIf="iconLeftClass && !loading"
      [ngClass]="iconLeftClass"
      class="btn-icon btn-icon--left"
      aria-hidden="true"
    ></i>

    <!-- Label -->
    <span class="btn-label">{{ label }}</span>

    <!-- Icône DROITE : Material Icons (string) -->
    <span
      *ngIf="iconRight && !iconRightClass && !loading"
      class="material-icons btn-icon btn-icon--right"
      aria-hidden="true"
      >{{ iconRight }}</span
    >

    <!-- Icône DROITE : classe personnalisée -->
    <i
      *ngIf="iconRightClass && !loading"
      [ngClass]="iconRightClass"
      class="btn-icon btn-icon--right"
      aria-hidden="true"
    ></i>
  </ng-container>
</button>
